import React from 'react';
import Paginate from 'rc-pagination';
import PropTypes from 'prop-types';
import 'rc-pagination/assets/index.css';
import './Pagination.scss';

export default function Pagination(props) {
  let { pageSize, totalItems, currentPage, onPageChange, disabled, className = '' } = props;

  return (
    <Paginate
      locale={{ next_page: 'صفحه بعد', prev_page: 'صفحه قبل' }}
      pageSize={pageSize}
      current={currentPage}
      total={totalItems}
      onChange={onPageChange}
      disabled={disabled}
      className={`school_pagination ${className}`}
    />
  );
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
